import { catchError, ObservableInput, OperatorFunction } from 'rxjs';

/** Records the error in state and rethrows it, so the NGXS action still ends up ERRORED. */
export function catchHttpError<T>(selector: (error: Error) => void): OperatorFunction<T, T> {
    return catchError<T, ObservableInput<T>>((error: Error) => {
        selector(error);
        throw error;
    });
}
